import { RecipeNutrition } from '../types';

export const nutritionSummaryDefinitions = [
  { code: 'ENERGY_KCAL', label: 'Energy' },
  { code: 'FAT', label: 'Fat' },
  { code: 'SATURATES', label: 'Saturates' },
  { code: 'SUGARS', label: 'Sugars' },
  { code: 'SALT', label: 'Salt' },
] as const;

export const getNutritionSummaryRows = (rows: RecipeNutrition[]) =>
  nutritionSummaryDefinitions.map((definition) => ({
    definition,
    row: rows.find(row => row.code.toUpperCase() === definition.code),
  }));
